/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'site.standard.theme.color'

type $nsid = typeof $nsid

export { $nsid }

type Rgb = {
  $type?: 'site.standard.theme.color#rgb'
  b: number
  g: number
  r: number
}

export type { Rgb }

const rgb = /*#__PURE__*/ l.typedObject<Rgb>(
  $nsid,
  'rgb',
  /*#__PURE__*/ l.object({
    b: /*#__PURE__*/ l.integer({ maximum: 255, minimum: 0 }),
    g: /*#__PURE__*/ l.integer({ maximum: 255, minimum: 0 }),
    r: /*#__PURE__*/ l.integer({ maximum: 255, minimum: 0 }),
  }),
)

export { rgb }

type Rgba = {
  $type?: 'site.standard.theme.color#rgba'
  a: number
  b: number
  g: number
  r: number
}

export type { Rgba }

const rgba = /*#__PURE__*/ l.typedObject<Rgba>(
  $nsid,
  'rgba',
  /*#__PURE__*/ l.object({
    a: /*#__PURE__*/ l.integer({ maximum: 100, minimum: 0 }),
    b: /*#__PURE__*/ l.integer({ maximum: 255, minimum: 0 }),
    g: /*#__PURE__*/ l.integer({ maximum: 255, minimum: 0 }),
    r: /*#__PURE__*/ l.integer({ maximum: 255, minimum: 0 }),
  }),
)

export { rgba }
